import React from "react";
import {
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
} from "@material-ui/core";

import { Icon } from "..";
import { MuiCard, MuiCardInfo } from "./style";
import { languageAr } from "../../utils/Translation";

export interface Props {
  src: string;
  title: string;
  like: string;
  download: string;
  projectId: string;
  languageCode: string;
  onLoad: (e: React.SyntheticEvent<HTMLDivElement, Event>) => void;
  onClick: () => void;
}

const IrregularItemView = ({
  src,
  title,
  like,
  download,
  projectId,
  languageCode,
  onLoad,
  onClick,
}: Props) => {
  const { className, dir } = languageAr(languageCode);

  return (
    <MuiCard id={projectId} variant="elevation" elevation={0} onLoad={onLoad}>
      <CardActionArea onClick={onClick}>
        <CardMedia
          width="100%"
          image={src}
          title={title}
          component="img"
          className="card-media"
        />
        <CardContent className="card-content">
          <MuiCardInfo className={className} dir={dir}>
            <span>
              <Icon name="download" size={13} /> {download}
            </span>
            <span>
              <Icon name="favorite" size={13} /> {like}
            </span>
          </MuiCardInfo>
          <Typography variant="subtitle2" component="p" dir={dir}>
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </MuiCard>
  );
};

export default IrregularItemView;
